import React, {Component} from 'react';
import {View} from 'react-native';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
//import { ip } from './ip';
//import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

//import cHome from './cHome';
import cView from './cView';

//class iHome extends cHome {
class iHome extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//    global.c = this; // current component, defined at ic.js、move_bwd で切り替わることを考慮し willFocux の中で設定
  }

  $id_stgs ={
  }

  $id_stss = {
  };

  $ilp_loads = () => [
  ];

  $ilp_upds = () => [
  ];

  _onPrcPrs = () => {
    let _d = {
      sgc_pageRole: global.c?.state.sgc_pageRole,
      sgc_pageName: 'iPrcList',
      sgc_pageKey: '', 
      sgc_pageMode: 'show',
    };
//alert('42: {}'.f(_d));
    cf.myRN_move_fwd(_d);
  };

  _onMngPrs = () => {
    let _d = {
      sgc_pageRole: global.c?.state.sgc_pageRole,
      sgc_pageName: 'iMngList',
      sgc_pageKey: '', 
      sgc_pageMode: 'show',
    };
//alert('51: {}'.f(_d));
    cf.myRN_move_fwd(_d);
  };

  render() {
//bf.l('62: {}, {}'.f(global.c?.state.sgcd_dmns))
    return (
<>
      <ce.Ldr />
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={false}
        rhtPfx={null}
        rhtIconName={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        d_hdrs={{
          pfx: iv._get_hdrPfx('ホーム'),
          logo: 'Mymemo',
          d_leftBtns: { 
            b_vsb: false,
            pfx: null,
            iconName: null,
            onPrs: null,
          },

          d_subMenus: {
            b_vsb: false,
          }
        }}
        n_bdyW={null /* ic.gn_maxBdyW */ }
        d_bdys={{
          d_stlInrs: {
//            height: ic.gn_bdyH,
            height: global.c?.state.sgcd_dmns.n_bdyH,
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignItems: 'center',
          },
          ld_defss: [
            {
              type: 'Btn',
              b_vsb: true,
              b_rvs: false,
//              pfx: '業務プロセス チェックシート',
              pfx: '業務知識・情報集約チェックシート',
              onPrs: global.c?._onPrcPrs,
              stlCta: {
//                height: ic.gn_bdyH / 5,
                height: global.c?.state.sgcd_dmns.n_bdyH / 5,
              },
              stlBtn: {
//                width: ic.gn_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                width: global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
              },
              stlPfx: {
//                lineHeight: ic.gn_bdyH / 5,
                lineHeight: global.c?.state.sgcd_dmns.n_bdyH / 5,
              },
            },
            {
              type: 'Btn',
              b_vsb: true,
              b_rvs: false,
              pfx: 'マネジメント見える化 チェックシート',
              onPrs: global.c?._onMngPrs,
              stlCta: {
//                height: ic.gn_bdyH / 5,
                height: global.c?.state.sgcd_dmns.n_bdyH / 5,
              },
              stlBtn: {
//                width: ic.gn_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                width: global.c?.state.sgcd_dmns.n_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
              },
              stlPfx: {
//                lineHeight: ic.gn_bdyH / 5,
                lineHeight: global.c?.state.sgcd_dmns.n_bdyH / 5,
              },
            },
          ],
        }}
      />
</>
    );
  };
};

/*
 */
export default iHome;
